import dynamic from 'next/dynamic';

const CustomerVehiclesListContent = dynamic(() =>
  import('./CustomerVehiclesListContent/CustomerVehiclesListContent')
);

const CustomerVehiclesGrid = dynamic(() =>
  import('./CustomerVehiclesGrid/CustomerVehiclesGrid')
);
const AddCustomerVehicleModal = dynamic(() =>
  import('./AddCustomerVehicleModal/AddCustomerVehicleModal')
);

const EditVehicleInfoModal = dynamic(() =>
  import('./EditVehicleInfo/EditVehicleInfoModal')
);

const CustomerVehicleBundles = dynamic(() =>
  import('./CustomerVehicleBundles/CustomerVehicleBundles')
);

const CustomerVehicleTaskSidebar = dynamic(() =>
  import('./CustomerVehicleTaskSidebar/CustomerVehicleTaskSidebar')
);

const CustomerVehicleTaskHeader = dynamic(() =>
  import('./CustomerVehicleTaskHeader/CustomerVehicleTaskHeader')
);

const CustomerVehiclesUsersTabContent = dynamic(() =>
  import('./CustomerVehiclesUsersTabContent/CustomerVehiclesUsersTabContent')
);

const CustomerVehiclesBundlesTabContent = dynamic(() =>
  import(
    './CustomerVehiclesBundlesTabContent/CustomerVehiclesBundlesTabContent'
  )
);

const CustomerVehiclesMediaTabContent = dynamic(() =>
  import('./CustomerVehiclesMediaTabContent/CustomerVehiclesMediaTabContent')
);
const CustomerVehiclesFilters = dynamic(() =>
  import('./CustomerVehiclesFilters/CustomerVehiclesFilters')
);

export {
  CustomerVehiclesListContent,
  CustomerVehiclesGrid,
  AddCustomerVehicleModal,
  EditVehicleInfoModal,
  CustomerVehicleBundles,
  CustomerVehicleTaskSidebar,
  CustomerVehicleTaskHeader,
  CustomerVehiclesUsersTabContent,
  CustomerVehiclesBundlesTabContent,
  CustomerVehiclesMediaTabContent,
  CustomerVehiclesFilters,
};
